module.exports = __webpack_public_path__ + "static/media/2-Diamond.699409b3.svg";